import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

const accountReviewStorageProvider = createModuleStorage(localStorage, "si:account-overview");

export default accountReviewStorageProvider;
